import React from 'react';
import debounce from 'lodash/debounce';
import { dataGenerator } from '../../utils';
import styles from './styles.scss';

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      selectedItems: [],
      selectedIds: [],
      searchedList: [],
      popUpFlag: true,
      selectedIndex: -1,
      loaded: false,
      updateFlag: false,
      defaultLoading: false,
    }
  }


  inputRef = React.createRef();
  searchedListRef = React.createRef();
  selectedItemsRef = React.createRef();


  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    if ( this.props.defaultList.length) {
      console.log('333333333333333333333333333333333,-------------------------------------------,', this.props.defaultList)
      this.setState(state => {
        this.props.defaultList.forEach(ele => state.selectedItems.push({
          userInfo: `${ele.fullName} ${ele.userName} ${ele.mobileNumber}`,
          id: ele.id
        }));
        return '';
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.loaded == false && this.props.searchedList.length) {
      this.setState(state => {
        state.searchedList = [...this.props.searchedList];
        state.loaded = true;
        return '';
      });
    }
 
  }

  selectSearchResultItem = (item, index) => {

    this.setState(state => {

      state.searchText = '';
      state.selectedItems.push(item);
      state.popUpFlag = true;
      state.selectedIndex = index;

      let deletationIndex = state.searchedList.findIndex(ele => ele.id == item.id);
      state.searchedList = state.searchedList.filter((_, index) => index !== deletationIndex);

      return '';

    }, () => {
      this.inputRef.current.style.height = `${this.selectedItemsRef.current.clientHeight + 30}px`;
    });

  };

  handleClickOutside = event => {
    if (this.searchedListRef.current && !this.searchedListRef.current.contains(event.target)) {
      this.setState(state => {
        state.popUpFlag = false;
        state.selectedItems.forEach(ele => state.selectedIds.push(ele.id));
        return '';
      }, () => {
        this.props.onSearchComplete([...new Set(this.state.selectedIds)]);
      })
    }
  }



  handleSearchInputChange = event => {

    let { value } = event.target;
    this.setState(state => {
      state.searchText = value;
      state.popUpFlag = true;
      return '';
    }, debounce(() => {
      this.props.onSearchInputChanged(this.state.searchText)
      this.setState({ loaded: false })
    }, 3000,
      {
        'maxWidth': 6000,
        'trailing': true,
        'leading': false,
      })

    );
  };

  deleteSelectedItem = (event, item, index) => {

    event.preventDefault();
    event.stopPropagation();

    this.setState(state => {
      state.popUpFlag = true;
      state.selectedItems = state.selectedItems.filter((item, ind) => index != ind);
      state.searchedList.splice(state.selectedIndex, 0, { ...item });
      return '';
    });

  }

  render() {

    let {
      searchInputClassName = '',
      id,
      name,
      inputErrorClassName,
      errorText,
      containerClassName = '',
    } = this.props;

    let {
      searchText,
      popUpFlag,
      searchedList,
      selectedItems
    } = this.state;

    return (
      <div
        ref={this.searchedListRef}
        className={containerClassName}
      >

        <div className={`d-flex flex-wrap ${searchInputClassName}`}>
          {selectedItems.map((item, index) => (
            <div
              onClick={(event) => this.deleteSelectedItem(event, item, index)}
              key={dataGenerator.generateKey('_selectedList')}
              className={`rounded bg-light pointer d-flex mx-2 ${styles['selected-items-heigth']} my-2`}
            >
              <span className='px-3'
              >
                {item.userInfo}</span>
              <span
                className='fa fa-times px-1' />
            </div>
          ))}
        </div>

        <div className={`${searchInputClassName} position-relative`}>
          <input
            onChange={this.handleSearchInputChange}
            ref={this.inputRef}
            id={id}
            placeholder={locales('titles.nameOrLastNameOrUsername')}
            name={name}
            type='text'
            value={searchText}
            className={`form-control ${inputErrorClassName} autocomplete-small-placeholder`}
          />
          <div className="invalid-feedback">
            {errorText}
          </div>
          {selectedItems.length ? <div
            ref={this.selectedItemsRef}
            className={`${styles['selected-items']} flex-wrap w-75 d-flex`}
          >

          </div>
            : null}
        </div>

        {popUpFlag && searchedList.length ? <div
          className={`border bg-light mx-3 ${styles['searched-list-container']}`}
        >
          {searchedList.map((item, index, self) => (
            <div
              onClick={() => this.selectSearchResultItem(item, index)}
              className={`pointer ${index < self.length - 1 ? 'border-bottom' : ''} p-3`}
              key={dataGenerator.generateKey('_searchedList')}
            >
              {item.userInfo}
            </div>
          ))}
        </div>
          : null}
      </div>
    )
  }

}
export default AutoComplete